import { useState } from 'react'
import { Form, Button, InputGroup } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { UpdateSiteParameter } from '../../../Services/ParameterService'
import { getParamTypeDefinition } from '../Config/paramTypes'
import { noAutofillProps } from '../Config/noAutofillProps'

const SiteParamRow = ({ dbRow, siteId, api, onSaved }) => {
    const definition = getParamTypeDefinition(dbRow.paramType)
    const initial = definition ? (dbRow[definition.valueKey] ?? '') : ''
    const [value, setValue] = useState(initial)
    const [savedValue, setSavedValue] = useState(initial)
    const [isSaving, setIsSaving] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    const isDirty = value !== savedValue

    const handleSave = () => {
        setIsSaving(true)
        UpdateSiteParameter(api, dbRow.paramId, siteId, dbRow.paramType, value)
            .then(() => {
                setSavedValue(value)
                onSaved?.(siteId, dbRow.paramId, definition.valueKey, value)
                toast.success(`Zapisano parametr`)
            })
            .catch(() => toast.error(`Błąd zapisu parametru!`))
            .finally(() => setIsSaving(false))
    }

    const renderInput = () => {
        if (definition.inputType === 'switch') {
            return (
                <Form.Check
                    type='switch'
                    id={`site-param-${siteId}-${dbRow.paramId}`}
                    checked={value === true || value === 'true'}
                    onChange={e => setValue(e.target.checked)}
                    className='mt-1'
                />
            )
        }

        if (definition.inputType === 'textarea') {
            return (
                <Form.Control
                    as='textarea'
                    rows={3}
                    value={value ?? ''}
                    onChange={e => setValue(e.target.value)}
                    size='sm'
                    {...noAutofillProps}
                />
            )
        }

        if (definition.inputType === 'password') {
            return (
                <InputGroup size='sm'>
                    <Form.Control
                        type={showPassword ? 'text' : 'password'}
                        value={value ?? ''}
                        onChange={e => setValue(e.target.value)}
                        {...noAutofillProps}
                        autoComplete='new-password'
                    />
                    <Button
                        variant='outline-primary'
                        onClick={() => setShowPassword(p => !p)}
                        tabIndex={-1}
                    >
                        {showPassword ? <FaEyeSlash size={15} /> : <FaEye size={15} />}
                    </Button>
                </InputGroup>
            )
        }

        return (
            <Form.Control
                type={definition.inputType}
                value={value ?? ''}
                onChange={e => setValue(e.target.value)}
                size='sm'
                {...noAutofillProps}
            />
        )
    }

    return (
        <tr>
            <td className='text-muted small align-middle' style={{ width: '35%' }}>
                {dbRow.paramDesc ?? dbRow.paramId}
                <div className='text-secondary' style={{ fontSize: '0.7rem' }}>{dbRow.paramId}</div>
            </td>
            {!definition && (
                <td className='text-secondary small align-middle' colSpan={2}>
                    Nieobsługiwany typ parametru: {dbRow.paramType ?? 'brak'}
                </td>
            )}
            {definition && (
                <>
                    <td className='align-middle' style={{ width: '55%' }}>
                        {renderInput()}
                    </td>
                    <td className='align-middle text-end' style={{ width: '10%' }}>
                        {definition.inputType !== 'switch' && (
                            <Button
                                size='sm'
                                variant={isDirty ? 'primary' : 'outline-secondary'}
                                disabled={!isDirty || isSaving}
                                onClick={handleSave}
                            >
                                {isSaving ? '...' : 'Zapisz'}
                            </Button>
                        )}
                        {definition.inputType === 'switch' && isDirty && (
                            <Button
                                size='sm'
                                variant='primary'
                                disabled={isSaving}
                                onClick={handleSave}
                            >
                                {isSaving ? '...' : 'Zapisz'}
                            </Button>
                        )}
                    </td>
                </>
            )}
        </tr>
    )
}

export default SiteParamRow
